import { onPageLoad } from '../modules/page_lifecycle.js';

import './bootstrap.js';

import './highcharts/highcharts_custom.js';
import './highcharts/base.js';
import './highcharts/donut.js';
import './highcharts/simple_bar.js';
import './highcharts/simple_column.js';
import './highcharts/stacked_bar.js';
import './highcharts/stacked_column.js';
import './highcharts/multiple_bar.js';
import './highcharts/multiple_column.js';
import './highcharts/new_multiple_column.js';
import './highcharts/map_chart.js';
import './highcharts/sunburst.js';
import './tables/ajax_table.js';
import './tables/ajax_table_bids_list.js';
import './tables/ajax_table_market_project.js';
import './tables/ajax_table_projects_list.js';
import './tables/ajax_table_transaction_event.js';
import './composites/side_by_side_sunburst.js';

function executeVisualizationInits() {
  document.querySelectorAll('script[data-viz-init]:not([data-viz-init-done])').forEach((script) => {
    try {
      // Server-rendered visualization bootstrap, not user-controlled input.
      // eslint-disable-next-line no-new-func
      new Function(script.textContent)();
      script.dataset.vizInitDone = 'true';
    } catch (error) {
      console.error('Visualization init failed:', error);
    }
  });
}

function flushSiteBundleQueue() {
  if (typeof globalThis.Highcharts === 'undefined') return false;
  if (!globalThis.Visualizations?.Highcharts?.Base?.renderChart) return false;

  globalThis.__siteBundleReady = true;
  (globalThis.__siteBundleQueue || []).forEach((fn) => {
    try {
      fn();
    } catch (error) {
      console.error('Site bundle visualization init failed:', error);
    }
  });
  globalThis.__siteBundleQueue = [];
  return true;
}

function bootVisualizationInits() {
  if (!flushSiteBundleQueue()) return;

  executeVisualizationInits();
}

const MAX_VIZ_BOOT_ATTEMPTS = 50;

function bootVisualizationInitsWithRetry(attempt = 0) {
  bootVisualizationInits();

  if (globalThis.__siteBundleReady || attempt >= MAX_VIZ_BOOT_ATTEMPTS) return;

  window.setTimeout(() => bootVisualizationInitsWithRetry(attempt + 1), 100);
}

onPageLoad(() => bootVisualizationInitsWithRetry());

if (!globalThis.__siteBundleReady) {
  document.addEventListener('DOMContentLoaded', () => bootVisualizationInitsWithRetry());
  window.addEventListener('load', () => bootVisualizationInitsWithRetry());
}
